export default {
  zh: {
    plexVpn: 'Plex加速器',
    email: '邮箱',
    phone: '手机号码'
  },
  en: {
    plexVpn: 'PlexVPN',
    email: 'Email',
    phone: 'Phone'
  }
}



// WEBPACK FOOTER //
// ./src/views/forgotpwd/forgotPwd/lang.js